import variables from '../theme/variables';
import SoundFXSprite from '../assets/audio/SoundFX.mp3';

import TapeDeck from '../components/tapeDeck/TapeDeck';
import Tools from '../components/tools/Tools';

import SecondaryMaquettesAudio from '../assets/audio/MaquettesAudio.mp3';
import SecondaryMaquettesImage from '../assets/img/MaquettesImage.webp';

import WorkDeskImage1 from '../assets/img/WorkDeskImage1.webp';
import WorkDeskImage2 from '../assets/img/WorkDeskImage2.webp';
import WorkDeskImage3 from '../assets/img/WorkDeskImage3.webp';

import DogPortraitImage1 from '../assets/img/DogPortraitImage1.webp';

// import DesignWorkImage from '../assets/img/DesignWorkImage.webp';
import ArtSuppliesImage from '../assets/img/ArtSuppliesImage.webp';

import ItalianLibraryImage1 from '../assets/img/ItalianLibraryImage1.webp';
import ItalianLibraryImage3 from '../assets/img/ItalianLibraryImage3.webp';
import ItalianLibraryImage4 from '../assets/img/ItalianLibraryImage4.webp';
import ItalianLibraryImage5 from '../assets/img/ItalianLibraryImage5.webp';
import ItalianLibraryImage6 from '../assets/img/ItalianLibraryImage6.webp';
import ItalianLibraryImage7 from '../assets/img/ItalianLibraryImage7.webp';
import ItalianLibraryImage8 from '../assets/img/ItalianLibraryImage8.webp';
import ItalianLibraryImage9 from '../assets/img/ItalianLibraryImage9.webp';

import WallClockImage from '../assets/img/WallClockImage.webp';
import DryEraseBoardImage from '../assets/img/DryEraseBoardImage.webp';

import Letter from '../components/letter/Letter';
import InspirationBoard from '../components/inspirationBoard/InspirationBoard';
import Splotch from '../components/splotch/Splotch';

export const secondaryInteractives = [
    {
        id: 'maquettes',
        position: {
            yaw: Math.PI * 1.22,
            pitch: Math.PI * 0.055,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'audio',
        sound: {
            mp3: SoundFXSprite,
            start: 2,
            duration: 1,
        },
        content: {
            title: 'Maquettes',
            copy: (
                <>
                    <p>
                        “Three-dimensional pieces, I had made in factories, in
                        metal shops, because I don’t have the technical
                        competence to do it myself, so these things are done by
                        other people. This is more traditional than the artist
                        as the talented hand because in former times, everyone
                        knows that artists had studios where a lot of the work
                        was done by other people too.”
                    </p>
                </>
            ),
            audio: SecondaryMaquettesAudio,
            image: SecondaryMaquettesImage,
        },
    },

    {
        id: 'workTable',
        position: {
            yaw: Math.PI * -0.15,
            pitch: Math.PI * 0.1,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'gallery',
        sound: {
            mp3: SoundFXSprite,
            start: 4,
            duration: 1,
        },
        content: {
            title: '<div style="text-align: center;">Worktable</div>',
            images: [
                WorkDeskImage1,
                WorkDeskImage2,
                WorkDeskImage3,
                // WorkDeskImage1,
                // WorkDeskImage2,
                // WorkDeskImage3,
            ],
            copy: (
                <p style={{ textAlign: 'center' }}>
                    Covered with years of paint, Sol’s worktable was his place
                    of doing, of creating.
                </p>
            ),
        },
    },

    {
        id: 'dogPortrait',
        position: {
            yaw: Math.PI * 0.1,
            pitch: Math.PI * 0,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'image',
        sound: {
            mp3: SoundFXSprite,
            start: 6,
            duration: 3,
        },
        content: {
            image: DogPortraitImage1,
            title: 'Lilla',
            copy: (
                <>
                    <p>
                        Notoriously camera shy, Sol once submitted a picture of
                        his beloved border collie, Lilla, to be used on the
                        cover of an art publication. This playful stunt raised
                        important questions about the role of art. Should the
                        work of art speak for itself?
                    </p>
                </>
            ),
        },
    },

    {
        id: 'artSupplies',
        position: {
            yaw: Math.PI * -0.33,
            pitch: Math.PI * 0.06,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'image',
        sound: {
            mp3: SoundFXSprite,
            start: 13,
            duration: 1,
        },
        content: {
            image: ArtSuppliesImage,
            title: 'Art Supplies',
            copy: (
                <p>
                    Every artist has a favorite medium. Sol used pencil,
                    gouache, and acrylic paint in bright primary colors to
                    materialize his concepts.
                </p>
            ),
        },
    },

    {
        id: 'italianLibrary',
        position: {
            yaw: Math.PI * -0.44,
            pitch: Math.PI * 0.03,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'gallery',
        sound: {
            mp3: SoundFXSprite,
            start: 15,
            duration: 1.5,
        },
        content: {
            images: [
                ItalianLibraryImage1,
                ItalianLibraryImage3,
                ItalianLibraryImage4,
                ItalianLibraryImage5,
                ItalianLibraryImage6,
                ItalianLibraryImage7,
                ItalianLibraryImage8,
                ItalianLibraryImage9,
            ],
            title: 'Biblioteca Panizzi',
            copy: (
                <p>
                    Collaborators, co-creators, and community make big art
                    happen on a colossal scale. Sol said of this monumental
                    installation in an Italian library, “I would like to produce
                    something that I would not be ashamed to show Giotto.”
                </p>
            ),
        },
    },

    {
        id: 'wallClock',
        position: {
            yaw: Math.PI * -0.03,
            pitch: Math.PI * -0.06,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'image',
        sound: {
            mp3: SoundFXSprite,
            start: 18,
            duration: 1,
        },
        content: {
            image: WallClockImage,
            title: 'Agenda',
            copy: (
                <>
                    <p>
                        Sol demanded punctuality. His strict daily schedule
                        balanced work with time to see friends, exercise, and
                        recharge.
                    </p>
                </>
            ),
        },
    },

    {
        id: 'dryEraseBoard',
        position: {
            yaw: Math.PI * 0.67,
            pitch: Math.PI * -0.02,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'image',
        sound: {
            mp3: SoundFXSprite,
            start: 21,
            duration: 1,
        },
        content: {
            image: DryEraseBoardImage,
            title: 'Perpetual Ideas',
            copy: (
                <>
                    <p>
                        Sol had many ongoing public projects. He understood that
                        art evolved over time, sometimes taking years to
                        manifest. He ensured his studio could complete his
                        projects and more for decades to come.
                    </p>
                </>
            ),
        },
    },

    {
        id: 'marioMerzObituary',
        position: {
            yaw: Math.PI * 0.03,
            pitch: Math.PI * -0.0,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        type: 'text',
        sound: {
            mp3: SoundFXSprite,
            start: 24,
            duration: 1,
        },
        content: {
            title: 'Mario Merz Obituary',
            copy: (
                <>
                    <p>
                        Each artist has a unique way of experiencing the world.
                        Some clash. Others form lifelong friendships despite
                        their differences.
                    </p>
                    <p>
                        <em>
                            &quot;I remember Mario Merz came to New York, he
                            stayed in my place endlessly and I had to tell him
                            he had to go, one day. It was so funny because his
                            schedule and my schedule were so different….I would
                            be getting up around six in the morning and he was
                            coming home from being out all night. He’d sleep all
                            day and I worked. We were really opposite, but after
                            about four weeks or so, I kicked him out and he was
                            very nice about me, he knew it was coming.&quot;
                        </em>
                    </p>
                </>
            ),
        },
    },
];

export const primaryInteractives = [
    {
        id: 'tapeDeck',
        hotspotTitle: 'Mixtapes',
        title: 'Browse Sol’s music<br />collection',
        subtitle: '',
        introAnimation: `${window.rootUrl}/lotties/PrimaryIntroTapeDeck.json`,
        introAnimationMobile: `${window.rootUrl}/lotties/PrimaryIntroTapeDeckMobile.json`,
        position: {
            yaw: Math.PI * 0.54,
            pitch: Math.PI * 0.05,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        sound: {
            mp3: SoundFXSprite,
            start: 0,
            duration: 1,
        },
        buttonTheme: 'light',
        backgroundColor: variables.palette.black,
        color: variables.palette.white,
        component: <TapeDeck />,
    },

    {
        id: 'splotchRenderings',
        hotspotTitle: 'Splotches',
        title: '2D&nbsp;to&nbsp;3D',
        subtitle:
            'Sol envisioned turning his abstract drawings he called footprints into 3D forms. From 2000-2007, he collaborated with sculpture fabricator Yoshi Nakama to make this happen. Together they created glossy, colorful sculptures called Splotches.',
        introAnimation: `${window.rootUrl}/lotties/PrimaryIntroSplotch.json`,
        introAnimationMobile: `${window.rootUrl}/lotties/PrimaryIntroSplotchMobile.json`,
        position: {
            yaw: Math.PI * 1.34,
            pitch: Math.PI * 0.045,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        sound: {
            mp3: SoundFXSprite,
            start: 0,
            duration: 1,
        },
        buttonTheme: 'dark',
        backgroundColor: variables.palette.grey.light,
        color: variables.palette.black,
        component: <Splotch />,
    },

    {
        id: 'tools',
        hotspotTitle: 'Create',
        title: 'Recreate a masterpiece',
        subtitle:
            'Sol worked with basic tools—a ruler, a triangle, a compass. The vision of his concept was clear before he even began. He explored space and location “as though it were a geographical exercise, and you had to go from here to there.” See <em>Wall Drawing #273</em>.',
        introAnimation: `${window.rootUrl}/lotties/PrimaryIntroTools.json`,
        introAnimationMobile: `${window.rootUrl}/lotties/PrimaryIntroToolsMobile.json`,
        position: {
            yaw: Math.PI * 0.41,
            pitch: Math.PI * 0.08,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        sound: {
            mp3: SoundFXSprite,
            start: 0,
            duration: 1,
        },
        buttonTheme: 'dark',
        backgroundColor: variables.palette.grey.light,
        color: variables.palette.black,
        component: <Tools />,
    },

    {
        id: 'evaHesse',
        hotspotTitle: 'Dear Eva',
        title: 'Dear Eva',
        subtitle:
            'Sol met Eva Hesse, a German-American sculptor, in 1960 at a party in New York. She wowed him with her artistic talent. In a famous letter to her, he told her to throw away her doubts, to "just DO."',
        introAnimation: `${window.rootUrl}/lotties/PrimaryIntroEva.json`,
        introAnimationMobile: `${window.rootUrl}/lotties/PrimaryIntroEvaMobile.json`,
        position: {
            yaw: Math.PI * 0.58,
            pitch: Math.PI * -0.04,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        sound: {
            mp3: SoundFXSprite,
            start: 0,
            duration: 1,
        },
        buttonTheme: 'dark',
        backgroundColor: variables.palette.white,
        color: variables.palette.black,
        component: <Letter />,
    },

    {
        id: 'inspirationBoard',
        hotspotTitle: 'Vision Board',
        title: 'Mentors&nbsp;& Musings',
        subtitle: `Sol was a visionary who realized his dream and started the Conceptual art movement. He was always trading work with other artists, seeking and finding the muse. He inspired his students at the School of Visual Arts—and many others—to achieve their dreams.`,
        introAnimation: `${window.rootUrl}/lotties/PrimaryIntroInspiration.json`,
        introAnimationMobile: `${window.rootUrl}/lotties/PrimaryIntroInspirationMobile.json`,
        position: {
            yaw: Math.PI * 0.89,
            pitch: Math.PI * -0.04,
            // yaw - left right - 0 2*PI
            // pitch - top down - -PI/2  ->  PI/2
        },
        sound: {
            mp3: SoundFXSprite,
            start: 0,
            duration: 1,
        },
        buttonTheme: 'light',
        backgroundColor: variables.palette.grey.dark,
        color: variables.palette.white,
        component: <InspirationBoard />,
    },
];
